import "./styles.scss";
import { Modal } from "../Modal";
import { mainStore } from "../../mainStore";
import { InputCopy } from "../InputCopy";
import { Divider } from "../Divider";
import { Button } from "../Button";
import { observer } from "mobx-react-lite";
import { fairnessStore } from "../../mainStore/fairnessStore";
import { useState, Suspense } from "react";
import { gameComponentsByGameId } from "../../constants/gameComponentsByGameId";
import { translationService } from "../../translationService";

export const FairnessModal = observer(() => {
  const [isOpenFairnessInfoModal, setIsOpenFairnessInfoModal] = useState(false);
  const LastRoundResult = gameComponentsByGameId[mainStore.gameId].LastRoundResult;
  const { t, TKeys } = translationService;
  return (
    <>
      {isOpenFairnessInfoModal ? (
        <FairnessInfoModal onBack={() => setIsOpenFairnessInfoModal(false)} />
      ) : (
        <Modal onClose={() => mainStore.setFairnessSectionOpened(false)} title={t(TKeys.PROVABLY_FAIRNESS)}>
          <Suspense fallback={null}>
            <LastRoundResult />
          </Suspense>
          <div className="key-salt-wrapper">
            <InputCopy
              className="key-salt-input"
              label={t(TKeys.KEY)}
              value={fairnessStore.lastResultData.key}
              onCopy={() => fairnessStore.setCheckHashData({ key: fairnessStore.lastResultData.key })}
            />
            <InputCopy
              className="key-salt-input"
              label={t(TKeys.SALT)}
              value={fairnessStore.lastResultData.salt}
              onCopy={() => fairnessStore.setCheckHashData({ salt: fairnessStore.lastResultData.salt })}
            />
          </div>

          <InputCopy label={t(TKeys.HASH)} value={fairnessStore.lastResultData.hash} />

          <Divider />
          <p className={"modal-item-title"}>{t(TKeys.CHECK_HASH)}</p>

          <div className="key-salt-wrapper">
            <InputCopy
              className="key-salt-input"
              label={t(TKeys.KEY)}
              value={fairnessStore.checkHashData.key || ""}
              handleInputChange={(value) => fairnessStore.setCheckHashData({ key: value })}
            />
            <InputCopy
              className="key-salt-input"
              label={t(TKeys.SALT)}
              value={fairnessStore.checkHashData.salt || ""}
              handleInputChange={(value) => fairnessStore.setCheckHashData({ salt: value })}
            />
          </div>

          <div className={"button-container"}>
            <Button onClick={() => fairnessStore.calculateHash()}>{t(TKeys.CHECK)}</Button>
          </div>

          <InputCopy label={t(TKeys.HASH)} value={fairnessStore.checkHashData.hash} />

          <Divider />
          <p className={"modal-item-title"}>{t(TKeys.NEXT_ROUND)}</p>

          <InputCopy label={t(TKeys.HASH)} value={fairnessStore.nextRoundHash} />

          <div className={"about-container"}>
            <p className={"modal-item-title about"} onClick={() => setIsOpenFairnessInfoModal(true)}>
              ? {t(TKeys.ABOUT_HASH)}
            </p>
          </div>
        </Modal>
      )}
    </>
  );
});

export const FairnessInfoModal = observer(({ onBack }) => {
  const { t, TKeys } = translationService;
  return (
    <Modal
      onBack={onBack}
      onClose={() => {
        onBack();
        mainStore.setFairnessSectionOpened(false);
      }}
      title={t(TKeys.ABOUT_HASH)}
    >
      <pre
        style={{
          color: "#fff",
          fontFamily: "Roboto, sans-serif",
          fontSize: "18px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {t(TKeys.ABOUT_HASH_DESCRIPTION)}
      </pre>
    </Modal>
  );
});
